import React from 'react'

import PropTypes from 'prop-types'

import { Menu } from './styles'

export default function Title({ label, noMargin, titleClass = '', fontSize, fontWeight }) {
    return (
      <div className={`d-flex ${noMargin ? 'mt-0' : 'mt-3 mb-2'}`}>
        <Menu className={titleClass} $fontSize={fontSize} $fontWeight={fontWeight}>
          {label}
        </Menu>
      </div>
    );
}

Title.propTypes = {
    label: PropTypes.string,
    noMargin: PropTypes.bool,
    titleClass: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
